import { useEffect, useMemo, useState } from 'react';
import debounce from 'lodash/debounce';
import { QuickSearch } from 'utils/shared';
import { IOptions } from 'ui/src/components/Form/shared/utils/options';

export default function useGetSearchOptions(value: string, debounceWait = 400) {
  const [debouncedValue, setDebouncedValue] = useState('');
  const debounceSearchValue = useMemo(
    () =>
      debounce((newValue) => {
        setDebouncedValue(newValue);
      }, debounceWait),
    [debounceWait],
  );
  debounceSearchValue(value);
  const [options, setOptions] = useState<IOptions[]>([]);
  useEffect(() => {
    if (debouncedValue.trim().length >= 3) {
      fetch(`${process.env.NEXT_PUBLIC_BASE_PATH}/api/quick-search/${encodeURIComponent(debouncedValue)}/?limit=5`)
        .then((resp) => resp.json())
        .then((resp) => {
          setOptions(
            resp?.map((result: QuickSearch['results'][number]) => ({
              label: result.title,
              value: result.slug.split('/blog')?.[1] ?? '',
            })) ?? [],
          );
        });
    } else {
      setOptions([]);
    }
  }, [debouncedValue]);

  return { options };
}
